export const createTicketFormErrors = {
  clientName: {
    required: 'Purpose of Analysis cannot be empty.',
    pattern: 'Purpose of Analysis cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  submitterName: {
    required: 'Submitter Name cannot be empty.',
    pattern: 'Submitter Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  itsmTool: {
    required: 'Source Name cannot be empty.',
    pattern: 'Source Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  industry: {
    required: 'Domain Name cannot be empty.',
    pattern: 'Domain Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  emailId: {
    required: 'Email Id cannot be empty.',
    pattern: 'Please enter valid email Id',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
};

export const createDocFormErrors = {
  clientName: {
    required: 'Purpose of Analysis cannot be empty.',
    pattern: 'Purpose of Analysis cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  submitterName: {
    required: 'Submitter Name cannot be empty.',
    pattern: 'Submitter Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  itsmTool: {
    required: 'Source Name cannot be empty.',
    pattern: 'Source Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  industry: {
    required: 'Domain Name cannot be empty.',
    pattern: 'Domain Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  document: {
    required: 'Document Type cannot be empty.',
    pattern: 'Document Type cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  emailId: {
    required: 'Email Id cannot be empty.',
    pattern: 'Please enter valid email Id',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
};

export const createConnectorFormErrors = {
  projectName: {
    required: 'Project Name cannot be empty.',
    pattern: 'Project Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  userId: {
    required: 'User Name cannot be empty.',
    pattern: 'User Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  password: {
    required: 'Password  cannot be empty.',
    pattern: 'Password cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  baseUrl: {
    required: 'Link cannot be empty.',
    pattern: 'Link should  be valid url',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  accessToken: {
    required: 'Access token cannot be empty.',
    pattern: 'Access token cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  callerName: {
    required: 'Project Name cannot be empty.',
    pattern: 'Project Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
};

export const calendarEventFormErrors = {
  eventName:{
    required: 'Event Name cannot be empty',
    pattern: '',
    minLength: '',
    maxLength: ''
  }
}

export const crateHealthMonitorFormErrors = {
  issueId: {
    required: 'Issue Id cannot be empty.',
    pattern: 'Issue Id cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  emailIds: {
    required: 'Email Id cannot be empty.',
    pattern: 'Please enter valid email id',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  }
};
export const logAnalysisFormErrors = {
  clientName: {
    required: 'Purpose of Analysis is required',
    pattern: 'Invalid characters in Purpose of Analysis',
    minLength: 'Purpose of Analysis must be at least 3 characters long',
    maxLength: 'Purpose of Analysis cannot exceed 30 characters'
  },
  team: {
    required: 'Team is required',
    pattern: 'Invalid characters in Team name',
    minLength: 'Team name must be at least 3 characters long',
    maxLength: 'Team name cannot exceed 30 characters'
  },
};

export const manageServiceFormErrors = {
  externalServiceName: {
    required: 'Application Name cannot be empty.',
    pattern: 'Application Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  assignmentGroup: {
    required: 'Assignment Group cannot be empty.',
    pattern: 'Assignment Group cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  priority: {
    required: 'Priority cannot be empty.',
    pattern: 'Priority cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  serviceGroup: {
    required: 'Service Group cannot be empty.',
    pattern: 'Service Group cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  externalUrl: {
    required: 'URL cannot be empty.',
    pattern: 'URL should  be valid',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
};

export const FILE_UPLOAD_ERRORS = {
	attachFile:{
		maxFileSize:'File size should not exceed',
		fileType:'filetype(s) are not supported.'
	}
};

export const relaibilityFormErrors = {
  sloName: {
    required: 'Slo Name cannot be empty.',
    pattern: 'Invalid characters in Slo Name',
    minLength: 'Slo Name must be at least 3 characters long',
    maxLength: 'Slo Name cannot exceed 30 characters'
  },
  targetSlo: {
    required: 'Target Slo cannot be empty.',
    pattern: 'Invalid characters in Target Slo',
    minLength: 'Target Slo must be at least 3 characters long',
    maxLength: 'Target Slo cannot exceed 30 characters'
  },
};

export const slefHelpPlaybookFormError = {
  name: {
    required: 'Playbook Name cannot be empty.',
    pattern: 'Invalid characters in Playbook Name',
    minLength: 'Playbook Name must be at least 3 characters long',
    maxLength: 'Playbook Name cannot exceed 30 characters'
  },
  description: {
    required: 'Description cannot be empty.',
    pattern: 'Invalid characters in Description',
    minLength: 'Description must be at least 3 characters long',
    maxLength: 'Description cannot exceed 30 characters'
  },
  url: {
    required: 'Link cannot be empty.',
    pattern: 'Invalid characters in Link',
    minLength: 'Link must be at least 3 characters long',
    maxLength: 'Link cannot exceed 30 characters'
  },
};

export const choasNewWorkflowkFormError = {
  name: {
    required: 'Workflow Name cannot be empty.',
    pattern: 'Invalid characters in Workflow Name',
    minLength: 'Workflow Name must be at least 3 characters long',
    maxLength: 'Workflow Name cannot exceed 30 characters'
  },
  description: {
    required: 'Description cannot be empty.',
    pattern: 'Invalid characters in Description',
    minLength: 'Description must be at least 3 characters long',
    maxLength: 'Description cannot exceed 30 characters'
  },
};
export const choasSettingsFormError = {
  baseUrl: {
    required: 'Url cannot be empty.',
    pattern: 'Invalid pattern in Url',
    minLength: '',
    maxLength: ''
  },
  bearerToken: {
    required: 'Access Token cannot be empty.',
    pattern: 'Invalid characters in Access Token',
    minLength: '',
    maxLength: ''
  },
  jobId:{
    required:"JobId is cannot be empty.",
    pattern:'Invalid JobId',
    minLength: '',
    maxLength: ''
  },
  parameter:{
    required:"Parameter is cannot be empty.",
    pattern:'Invalid parameter',
    minLength: '',
    maxLength: ''
  },
  value:{
    required:"Value is cannot be empty.",
    pattern:'Invalid Value',
    minLength: '',
    maxLength: ''
  },
  jobName:{
    required:"Job Name is cannot be empty.",
    pattern:'Invalid Job Name',
    minLength: '',
    maxLength: ''
  },
  runtimeValue:{
    required:"Runtime Variables cannot be empty.",
    pattern:'Invalid parameter',
    minLength: '',
    maxLength: ''
  },
  runtimeKey:{
    required:"Runtime Display Name is cannot be empty.",
    pattern:'Invalid Value',
    minLength: '',
    maxLength: ''
  },
  userName: {
    required: 'User Name cannot be empty.',
    pattern: 'User Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
    password: {
    required: 'Password cannot be empty.',
    pattern: 'Password cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
};

export const choasStartFormError = {
  serverName: {
    required: 'Server Name cannot be empty.',
    pattern: 'Invalid pattern in Server Name',
    minLength: '',
    maxLength: ''
  },
  resourceGroup: {
    required: 'Resource Group cannot be empty.',
    pattern: 'Invalid characters in Resource Group',
    minLength: '',
    maxLength: ''
  },
};

export const createMonitoringServicesError = {
  userName: {
    required: 'User Name cannot be empty.',
    pattern: 'User Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  apimId: {
    required: 'APIM ID cannot be empty.',
    pattern: 'APIM ID cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  process: {
    required: 'process  cannot be empty.',
    pattern: 'process cannot be empty',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  url: {
    required: 'url cannot be empty.',
    pattern: 'url should  be valid',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  accessToken: {
    required: 'Access token cannot be empty.',
    pattern: 'Access token cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  applicationName: {
    required: 'Application Name cannot be empty.',
    pattern: 'Application Name cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },
  password: {
    required: 'Password cannot be empty.',
    pattern: 'Password cannot contain special characters',
    minLength: 'length should be 3 characters',
    maxLength: 'length should not greater than 30 characters'
  },

};



